import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

export const Testimonial = ({ t, variant = "dark", testId }) => {
  const [open, setOpen] = useState(false);
  const dark = variant === "dark";
  const quoteColor = dark ? "text-[#F5F0E8]" : "text-[#1A2535]";
  const attrColor = dark ? "text-[#F5F0E8]/60" : "text-[#1A2535]/55";
  const bodyColor = dark ? "text-[#F5F0E8]/85" : "text-[#1A2535]/80";

  return (
    <div className="max-w-2xl mx-auto text-center" data-testid={testId}>
      {/* thin gold divider separating section content from the testimonial */}
      <div
        className="w-full h-px bg-[#C9A84C]/60 mx-auto mb-10"
        aria-hidden="true"
      />

      <blockquote
        className={`font-serif italic ${quoteColor} text-2xl sm:text-3xl leading-snug`}
      >
        &ldquo;{t.quote}&rdquo;
      </blockquote>

      <div className="mt-5 flex items-center justify-center gap-3.5">
        <span className="w-14 h-14 rounded-full overflow-hidden border border-[#C9A84C] shrink-0 block">
          <img
            src={t.photo}
            alt={t.name}
            loading="lazy"
            className="w-full h-full object-cover rounded-full"
          />
        </span>
        <p
          className={`font-sans text-[0.68rem] sm:text-xs tracking-[0.2em] uppercase ${attrColor} text-left`}
        >
          {[t.name, t.role, t.location].filter(Boolean).join(" / ")}
        </p>
      </div>

      <button
        type="button"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
        data-testid={`${testId}-toggle`}
        className="mt-3 inline-flex items-center gap-2 text-[#C9A84C] text-xs sm:text-sm tracking-[0.12em] uppercase hover:text-[#D4691E] transition-colors duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A84C]/50 rounded-sm"
      >
        {open ? `Hide ${t.name}'s story` : `Read ${t.name}'s full story`}
        <span
          aria-hidden="true"
          className={`transition-transform duration-500 ${
            open ? "rotate-180" : ""
          }`}
        >
          &#8595;
        </span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
            data-testid={`${testId}-panel`}
          >
            <div
              className={`pt-8 space-y-4 font-sans font-light text-base sm:text-lg leading-relaxed text-left ${bodyColor}`}
            >
              {t.full.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
